var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesForum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -1770) translate(444 1770)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7EB2EA",
    d: "M11.88 42.448L11.88 69.244 40.172 69.244 50.732 77.296 50.732 69.244 58.828 69.244 58.828 42.448 11.88 42.448",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23B34A",
    d: "M3.88 5.448L3.88 32.244 32.172 32.244 42.732 40.296 42.732 32.244 50.828 32.244 50.828 5.448 3.88 5.448",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M75.572 25.068L75.572 51.864 47.236 51.864 36.676 59.916 36.676 51.864 28.624 51.864 28.624 25.068 75.572 25.068",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3677D6",
    d: "M17.688 52.876L26.312 52.876 26.312 49.884 17.688 49.884z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F7940",
    d: "M9.688 15.876L18.312 15.876 18.312 12.884 14.507 12.884 9.688 12.884z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3677D6",
    d: "M17.688 61.456L35.112 61.456 35.112 58.508 17.688 58.508z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F7940",
    d: "M9.688 24.456L19.392 24.456 27.112 24.456 27.112 21.508 9.688 21.508z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE88E",
    d: "M34.432 35.496L66.356 35.496 69.764 35.496 69.764 32.504 34.432 32.504zM34.432 44.076L58.463 44.076 62.196 44.076 62.196 41.128 34.432 41.128z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3677D6",
    d: "M45.76 61.456L53.196 61.456 53.196 58.508 45.76 58.508z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F7940",
    d: "M37.76 24.456L45.196 24.456 45.196 21.508 37.76 21.508z",
    transform: "translate(-444 -1770) translate(444 1770) translate(5 3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesForum);
export default __webpack_public_path__ + "static/media/features-forum.62899a4d.svg";
export { ForwardRef as ReactComponent };